import { createModule } from '../../createModule';
export const createManagementReportAPI = createModule(({ http }) => {
    return {
        getReport: async (params) => {
            const res = await http.get('/v2/management-report/', { params });
            return res;
        },
    };
});
